import { createFileRoute, notFound } from "@tanstack/react-router";
export const Route = createFileRoute("/status-style-preview/$state")({ beforeLoad: () => { throw notFound(); } });